import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod/v4'

export const Route = createFileRoute('/_auth/register')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/inscription' })
  },
  validateSearch: z.object({
    email: z.email().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  }),
})
